import React, { FC, useCallback } from "react";
import classNames from "classnames/dedupe";
import { THeroBannerSlide } from "./HeroBanner.interface";
import { Link } from "../../ActionsSelectors/Link";

export interface IHeroBannerThumbSlideProps {
  /** Banner/widget data */
  banner: THeroBannerSlide;
}

const HeroBannerThumbSlide: FC<IHeroBannerThumbSlideProps> = ({ banner }) => {
  const title = banner.shortTitle || banner.title;
  const onSlideClick = useCallback((e: MouseEvent) => {
    e.preventDefault();
  }, []);

  return (
    <li
      key={title as string}
      className={`nav-item ${banner.classes?.root || ""}`}
    >
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <Link
        classes={{
          root: classNames(
            "nav-link cursor-pointer",
            banner.link?.classes?.root,
          ),
        }}
        title={title as string}
        onClick={onSlideClick}
      >
        <span className="d-block d--webkit-box max-lines max-lines--2">
          {title}
        </span>
      </Link>
    </li>
  );
};

export default HeroBannerThumbSlide;
